<template lang='pug'>
v-card(class='with-pointer mh100 flex-card')
  div(class="complex-state" :class="[complex.state_id, { published: complex.published == 1, presale: complex.show_about_project == 1} ]" )
    | {{ complexStateName }}
  div(@click='$emit("click", complex)')
    v-img(
      v-if='complex.avatar_url'
      :src='complex.avatar_url'
      :lazy-src='complex.avatar_url'
      :aspect-ratio='16/9'
      class='grey lighten-4'
    )
      v-layout(slot='placeholder' fill-height align-center justify-center ma-0)
        v-progress-circular(indeterminate color='primary')
    v-img(v-else src='/img-placeholder.png' :aspect-ratio='16/9' class='white')
    v-card-title(primary-title)
      v-flex(d-block pa-0)
        v-chip(
          :color="complex.excursion_enabled==1 ? `#f4bb36` : 'gray'"
          :key="complex.id"
          text-color="white"
          small
        ) Экскурсии
        h3(class='headline mb-0 text-truncate')
          | {{ complex.complex_name || '&nbsp;' }}
        div(class='mt-1')
          a(
            @click.stop
            :href='complexAboutLink'
            class='dev-link'
            target='_blank'
          )
            | Перейти на страницу "О проекте"             
        div(v-if='complex.developer' class='mt-1')
          div(class='grey--text text-truncate') Застройщик:
          | {{ complex.developer.developer_name }}
        div(v-if='complex.dvizh_uuid' class='mt-1')
          div(class='grey--text text-truncate') ДВИЖ UUID:
          | {{complex.dvizh_uuid}}
    meta-data(
      v-if='complex.complex_info'
      :complex='complex.complex_info'
      :date='complex.due_date'
    )
  v-card-actions
    v-spacer
    v-btn(@click.stop='$emit("remove", complex)' flat small) Удалить
    v-btn(@click.stop='$emit("edit", complex)' flat small) Редактировать
</template>

<script>
import MetaData from './MetaData'

export default {
  props: ['complex'],
  components: {
    MetaData
  },
  computed: {
    complexStateName() {
      if(this.complex.state_id=='finished') return 'Реализован'
      if(this.complex.show_about_project) return 'Предпродажа'
      if(this.complex.state_id=='inprogress') return 'В продаже'
      if(this.complex.state_id=='draft') return 'Черновик'
      return 'Созидание'
    },
    complexAboutLink() {
      return 'https://unistroyrf.ru/objects/' + this.complex.complex_code;
    }
  }
}
</script>

<style scoped>
.dev-link {
  font-size: 11px;
}

.complex-state {
  padding: 3px 15px;
  display: block;
  flex: none !important;
}

.complex-state.presale {
  background-color: #ff0000 ;
  color: white;
}

.complex-state.published {
  background-color: #27ae60 ;
  color: white;
}


.complex-state.finished {
  background-color: #ffac11 ;
  color: white;
}

.complex-state.draft {
  background-color: #c4c4c4 ;
  color: white;
}

</style>
